export const FETCH_PCO_AUTH_STATUS_START = 'FETCH_PCO_AUTH_STATUS_START';
export const FETCH_PCO_AUTH_STATUS_SUCCESS = 'FETCH_PCO_AUTH_STATUS_SUCCESS';
export const FETCH_PCO_AUTH_STATUS_FAILURE = 'FETCH_PCO_AUTH_STATUS_FAILURE';

export const FETCH_PCO_SONGS_START = 'FETCH_PCO_SONGS_START';
export const FETCH_PCO_SONGS_SUCCESS = 'FETCH_PCO_SONGS_SUCCESS';
export const FETCH_PCO_SONGS_FAILURE = 'FETCH_PCO_SONGS_FAILURE';

export const FETCH_PCO_SONG_DETAIL_START = 'FETCH_PCO_SONG_DETAIL_START';
export const FETCH_PCO_SONG_DETAIL_SUCCESS = 'FETCH_PCO_SONG_DETAIL_SUCCESS';
export const FETCH_PCO_SONG_DETAIL_FAILURE = 'FETCH_PCO_SONG_DETAIL_FAILURE';
